// Node
const $ = require('jquery');
require('jquery.cookie');
require('inputmask');

// Custom
import moment from 'moment';
import FunnySadDialog from 'new_design/common/funny-sad-dialog';

class CallbackWidget {
  static init(widgetId) {
    let widget = new CallbackWidget(widgetId);

    widget._init();

    return widget;
  }

  constructor(widgetId) {
    this.widgetId = widgetId;

    this.$widget = $(`#${widgetId}`);
    this.$form = this.$widget.find('form');

    this.$closeBtn = this.$widget.find('.popup-close');
    this.$orderBtn = this.$widget.find('button[type="submit"]');
    this.$orderName = this.$widget.find('input#name');
    this.$orderNumber = this.$widget.find('input#number');

    this.$errorsField = this.$widget.find('.errors_phone');
    this.$spinner = this.$widget.find('#progress');
  }

  open() {
    window.ymReachGoal('callback-button-metrika');
  }

  close() {
    this.$closeBtn.trigger('click');
  }

  _order() {
    this._validate() && this._sendRequest();
  }

  _init() {
    this.$orderNumber.each(function () {
      Inputmask('+7 (999) 999-99-99').mask(this);
    });

    this._hideBySchedule();
    this._eventsInit();
    this._selectTimeStop();
    this._selectDropDown();
  }

  _hideBySchedule() {
    moment.locale('ru');
    const schedule = $('#callback_btn').data('schedule');
    if (!schedule || !schedule.find) {
      $('#callback_btn').hide();
      return;
    }
    const weekday = moment().weekday() == 6 ? 0 : moment().weekday() + 1;
    const day = schedule.find((s) => s.day == weekday);
    if (!day) $('#callback_btn').hide();
    const dateFrom = moment(day.time_from + ' +0300', 'HH:mm ZZ');
    const dateTo = moment(day.time_to + ' +0300', 'HH:mm ZZ');
    if (dateFrom.isAfter(moment()) || dateTo.isBefore(moment()) || !day.enabled) {
      $('#callback_btn').hide();
    }
  }

  // Убирает стандартное действие с селекта в выборе времени звонка
  _selectTimeStop() {
    $('.popup .call-wrap .mdc-select select').on('click', function (e) {
      e.preventDefault();
      this.blur();
      window.focus();
    });
  }

  _selectDropDown() {
    $('.call-back .mdc-select').on('click', (e) => {
      $('.mdc-menu-surface').css('z-index', '1100');
    });
  }

  _eventsInit() {
    this.$form.on('submit', (event) => {
      event.preventDefault();

      this._order();
    });

    $(`div[rel="${this.widgetId}"]`).on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.open();
    });
  }

  _validate() {
    if (/^\+7 \(9\d{2}\) \d{3}-\d{2}-\d{2}$/.test(this.$orderNumber.val())) {
      if (!this.$errorsField.is(':empty')) {
        this.$errorsField.empty();
      }
      return true;
    } else {
      if (this.$errorsField.is(':empty')) {
        this.$errorsField.append('<span>Некорректный формат номера</span>');
      }
      return false;
    }
  }

  _sendRequest() {
    $.ajax({
      type: 'POST',
      url: '/callback_orders',
      data: {
        name: this.$orderName.val(),
        call: {
          name: this.$orderName.val(),
          number: this.$orderNumber.val(),
          callable_id: this.$orderBtn.data().callableId,
          callable_type: this.$orderBtn.data().callableType,
        },
        sales_channel_id: $.cookie('sales_channel_id'),
        website_type: window.website_type,
      },
      beforeSend: () => {
        this._setLoading();
      },
      success: (data) => {
        FunnySadDialog.createFunnyDialog('Заказ звонка успешно принят!', 'Ожидайте, с Вами свяжется наш менеджер');
        window.ymReachGoal('callback-success-metrika');
      },
      error: (err) => {
        FunnySadDialog.createSadDialog('Упс, что-то пошло не так', 'Попробуйте еще раз через пару минут.');
        window.ymReachGoal('callback-error-metrika');
      },
      complete: () => {
        this._unsetLoading();
        this.close();
      },
    });
  }

  _setLoading() {
    this.$orderBtn.prop('disabled', true);
    this.$orderBtn.hide();
    this.$spinner.removeClass('hidden');
  }

  _unsetLoading() {
    this.$orderBtn.prop('disabled', false);
    this.$orderBtn.show();
    this.$spinner.addClass('hidden');
  }
}

export { CallbackWidget };
